module.exports = __webpack_public_path__ + "img/selected3-min.c9829286.png";